import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {timeOutline, timeSharp} from "ionicons/icons"
import {useHistory} from "react-router";
import Lock from "@customTypes/Lock";

interface props {
    lock: Lock
}

const ListItemButtonLockTimeLimits: React.FC<props> = ({ lock }) => {

    const { t } = useTranslation()
    const history = useHistory()
    const [presentAlert] = useIonAlert()

    const lockTimeLimitsCount = lock.lockTimeLimits?.length ?? 0
    const translationKey = `locks.alerts.${lockTimeLimitsCount > 0 ? 'time_limits' : 'no_time_limits'}`

    const alertMessage = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t(translationKey + '.header'),
            message: t(translationKey + '.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    const goToLockView = (ev: any) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (lockTimeLimitsCount > 0) {
            return history.push('/locks/' + lock.id + '/view')
        }

        alertMessage(ev)
    }

    return (
        <IonButton
            color={lockTimeLimitsCount > 0 ? "medium" : "light"}
            fill="clear"
            onClick={ (ev) => goToLockView(ev) }
            shape="round"
            size="large"
            style={{ 'fontSize': '1rem' }}
        >
            <IonIcon slot="start" ios={timeOutline} md={timeSharp} />
        </IonButton>
    )
}

export default ListItemButtonLockTimeLimits